import { Button } from "@/components/ui/button";

const Hero = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="pt-24 md:pt-32 pb-10 md:pb-14 bg-white"
      aria-labelledby="hero-title"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-4xl">
          {/* Main Title */}
          <h1
            id="hero-title"
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 tracking-tight leading-tight font-['Manrope'] animate-fade-in"
          >
            Nous nous occupons de vos chiffres, vous vous occupez de votre activité.
          </h1>

          {/* Subtitle */}
          <p className="mt-6 md:mt-8 text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl animate-fade-in animate-delay-100">
            Votre fiduciaire de confiance en Suisse romande. Comptabilité, fiscalité et conseil pour indépendants, Sàrl et SA.
          </p>

          {/* CTA Buttons */}
          <div className="mt-8 md:mt-10 flex flex-col sm:flex-row gap-4 animate-fade-in animate-delay-200">
            <Button
              onClick={(e) => scrollToSection(e, "#contact")}
              className="bg-blue-600 hover:bg-blue-700 text-white rounded-full px-8 py-6 text-base font-medium btn-primary"
              data-testid="hero-cta-primary"
            >
              Prendre rendez-vous
            </Button>
            <Button
              onClick={(e) => scrollToSection(e, "#services")}
              variant="outline"
              className="border-blue-600 text-blue-600 hover:bg-blue-50 rounded-full px-8 py-6 text-base font-medium"
              data-testid="hero-cta-secondary"
            >
              Découvrir nos services
            </Button>
          </div>
        </div>

        {/* Decorative element - subtle geometric pattern */}
        <div className="hidden lg:block absolute top-32 right-12 w-64 h-64 opacity-5">
          <div className="grid grid-cols-8 gap-2">
            {Array.from({ length: 64 }).map((_, i) => (
              <div key={i} className="w-2 h-2 rounded-full bg-blue-600" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
